import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from 'react-router-dom';
import { GenericLayout } from './styles/layouts';
import { Detail, Home, About } from './pages';
import { css, Global } from '@emotion/react';
import { List } from './pages/List/List';
import { Absence } from './pages/Absence/Absence';
import { BASENAME } from 'config/constants';

const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        * {
          box-sizing: border-box;
        }

        body {
          font-family: 'IBM Plex Sans', sans-serif;
          margin: 0;
        }
      `}
    />
  );
};

const App = () => {
  return (
    <Router basename={BASENAME}>
      <GlobalStyles />
      <Routes>
        <Route element={<GenericLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/list" element={<List />} />
          <Route path="/absence" element={<Absence />} />
          <Route path="/about" element={<About />} />
          <Route path="/detail" element={<Outlet />}>
            <Route path=":detailId" element={<Detail />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
